import { twMerge } from 'tailwind-merge';
import { clsx, type ClassValue } from 'clsx';
import axios from 'axios';
import { Roles } from '@/constants/users.constants';
import { OrganizationType } from '@/constants/organizations.constants';
import { JWTUserType } from '@/types/Auth';

export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args));
}

export const isAuthorized = (roles: Roles[], allowedRoles: Roles[]) => {
  return roles.some((role) => {
    return allowedRoles.includes(role);
  });
};

export const handleError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const apiError =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      (error?.response as any)?.message ||
      'An unexpected error occurred';

    return {
      message: apiError,
      errors: {},
    };
  }
  const errors = handleValidationError(error);

  return {
    message: (error as any)?.message ?? 'An unexpected error occurred',
    errors,
  };
};

interface ValidationError {
  validation?: {
    body?: {
      keys: string[];
      message: string;
    };
  };
}

export const handleValidationError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const validationError = error.response?.data as ValidationError;

    if (validationError?.validation?.body) {
      const { keys, message } = validationError.validation.body;

      // Convert to Formik errors object format
      return keys.reduce(
        (acc, key) => {
          acc[key] = message;
          return acc;
        },
        {} as Record<string, string>,
      );
    }
  }
  return {};
};

export const isMigeprof = (user?: JWTUserType) => {
  return user?.organization?.type === OrganizationType.MIGEPROF;
};
